module.exports = __webpack_public_path__ + "media/operation scar.93116917.wav";